/**
 * Obuna / marketing addon to'lov initiate xatolarini foydalanuvchiga tushunarli matnga aylantiradi.
 */
export function resolveSubscriptionPaymentError(
  t: (key: string) => string,
  err: unknown,
  fallbackKey = 'subscription_pay_err_generic',
): string {
  const apiData =
    err && typeof err === 'object' && 'data' in err
      ? ((err as { data?: { message?: string; code?: string } }).data ?? null)
      : null;

  const code = apiData?.code != null ? String(apiData.code).trim() : '';
  const codeToKey: Record<string, string> = {
    PAYME_TEST_MERCHANT_REQUIRED: 'subscription_pay_err_payme_test_merchant',
    PAYME_NOT_CONFIGURED: 'subscription_pay_err_payme_not_configured',
    PAYME_INVALID_MERCHANT_ID: 'subscription_pay_err_payme_invalid_merchant',
    PAYME_KEY_NOT_CONFIGURED: 'subscription_pay_err_payme_key_not_configured',
    PAYME_PRODUCTION_CHECKOUT_REQUIRED: 'subscription_pay_err_payme_production_checkout',
  };

  if (code && codeToKey[code]) {
    const translated = t(codeToKey[code]);
    if (translated && translated !== codeToKey[code]) {
      return translated;
    }
  }

  const apiMessage = apiData?.message != null ? String(apiData.message).trim() : '';
  if (apiMessage) {
    return apiMessage;
  }

  if (err instanceof Error && err.message.trim()) {
    return err.message;
  }

  return t(fallbackKey) || "To'lov boshlanmadi. Qaytadan urining.";
}
